import { authHeader } from '@/helpers/auth-header'
import { commons } from './commons'

export const shipmentInfoService = {
  getArrivalVessels,
  getDepartureVessels,
}

const resourceUrl = process.env.VUE_APP_GSCV_ENGINE_URL + `/shipment-info`

function getArrivalVessels() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  }
  return fetch(resourceUrl + `/arrival-vessels`, requestOptions).then(commons.handleJsonResponse)
}

function getDepartureVessels() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  }
  return fetch(resourceUrl + `/departure-vessels`, requestOptions).then(commons.handleJsonResponse)
}
